import React from 'react';

import TitleBar from 'shared/migration-components/title-bar';
import Tabs, {TabProps} from 'shared/migration-components/tabs';
import styled from 'styled-components';

import {EditDeliveryMan, EditMotorcycle} from './components';

import useAccessControls from 'modules/access-controls/atoms/use-access-controls';

interface Props {
  activeTab?: string;
}

const DeliveryManDetails: React.FC<Props> = ({activeTab}) => {
  const {isAllowed} = useAccessControls();

  const tabs: TabProps[] = [
    {
      label: 'Editar entregador',
      content: <EditDeliveryMan />,
      hidden: !isAllowed('deliveryMen.findOne'),
    },
    {
      tab: 'motorcycle',
      label: 'Moto',
      content: <EditMotorcycle />,
      hidden: !isAllowed('deliveryMen.findOne'),
      createUrl: 'create',
    },
  ];

  return (
    <Container>
      <TitleBar
        title="Detalhes do entregador"
        backUrl="/settings/delivery-men"
      />
      <Tabs {...{activeTab, tabs}} />
    </Container>
  );
};

export default DeliveryManDetails;

const Container = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  gap: 15px;
`;
